<template>
  <div>
    <Lfw v-if="$store.state.eventInfo.TemplateId == 1"></Lfw>
    <Pkl v-else-if="$store.state.eventInfo.TemplateId == 2"></Pkl>
    <IccTeamReg v-else-if="$store.state.eventInfo.TemplateId == 11"></IccTeamReg>
    <DnaEvent v-else-if="$store.state.eventInfo.TemplateId == 3"></DnaEvent>
    <SMatch v-else-if="$store.state.eventInfo.TemplateId == 4"></SMatch>
    <Icc v-else-if="$store.state.eventInfo.TemplateId == 5"></Icc>
    <PklWid v-else-if="$store.state.eventInfo.TemplateId == 6"></PklWid>
    <Ilt20 v-else-if="$store.state.eventInfo.TemplateId == 7"></Ilt20>
    <Ioc v-else-if="$store.state.eventInfo.TemplateId == 9"></Ioc>
    <SuperCross v-else-if="$store.state.eventInfo.TemplateId == 10"></SuperCross>
    <Nmacc v-else-if="$store.state.eventInfo.TemplateId == 8"></Nmacc>
  </div>
</template>

<script>
import Lfw from "../components/templates/lfw";
import Pkl from "../components/templates/pkl";
import DnaEvent from "../components/templates/nmaccNyc";
import SMatch from "../components/templates/sMatch";
import Icc from "../components/templates/icc";
import Ilt20 from "../components/templates/ilt20";
import PklWid from "../components/templates/pklWid";
import Nmacc from "../components/templates/nmacc";
import Ioc from "../components/templates/ioc";
import SuperCross from "../components/templates/superCross";
import IccTeamReg from "../components/templates/iccform/teamReg";

export default {
  components: { Lfw, Pkl, DnaEvent, SMatch, Icc, Ilt20, PklWid, Nmacc, Ioc, SuperCross, IccTeamReg},
};
</script>

<style>
</style>